// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__23mU6","notes":"Notes_notes__1EqG3","note":"Notes_note__2slAK","markdown":"Notes_markdown__2zQJt"};